import Box from '@totallymoney/ui/components/Box'
import Heading from '@totallymoney/ui/components/Heading'
import Row from '@totallymoney/ui/components/Row'
import Icon from '@totallymoney/ui/icons/Icon'
import theme from '@totallymoney/ui/theme'

import { ScoredCreditCardProduct } from '@appTypes/EligibilityApi.interface'

import UnorderedList, { ListItem } from '@components/UnorderedList'

import { borderStyle } from '@styles/borderStyle'

interface CardPageProductDetailsSectionProps {
    heading: string
    icon: 'alertCheckmark' | 'gauge' | 'star' | 'warning'
    list: string[]
}

const CardPageProductDetailSection = ({
    heading,
    icon,
    list,
}: CardPageProductDetailsSectionProps) => (
    <Box>
        <Row
            space="space15"
            pb="space10"
            mb="space20"
            alignItems="center"
            borderBottom={borderStyle}
        >
            <Icon icon={icon} size={20} color={theme.grey100} />
            <Heading variant="40">{heading}</Heading>
        </Row>

        <UnorderedList>
            {list?.map((listItem, i) => (
                <ListItem key={`${listItem}-${i}`}>{listItem}</ListItem>
            ))}
        </UnorderedList>
    </Box>
)

const CardPageProductLists = ({ card }: { card: ScoredCreditCardProduct }) => (
    <Box
        display="grid"
        gridTemplateColumns={['1fr', '1fr 1fr']}
        gridRowGap="space30"
        gridColumnGap={['space30', 'space50']}
        pb={['space30', 'space40']}
    >
        <CardPageProductDetailSection
            heading="Key benefits"
            icon="alertCheckmark"
            list={card.pros}
        />

        <CardPageProductDetailSection
            heading="More details"
            icon="warning"
            list={card.cons}
        />

        <CardPageProductDetailSection
            heading="Useful information"
            icon="star"
            list={card.features}
        />

        <CardPageProductDetailSection
            heading="Eligibility"
            icon="gauge"
            list={card.eligibility}
        />
    </Box>
)

export default CardPageProductLists
